export default "__VITE_ASSET__CXy7zB8Y__"